'use client';

import {PageLoader} from 'app/components/core/Page/PageLoader';
import {useAuthentication} from 'app/hooks/useAuthentication';
import {LogoLink} from 'app/components/core/Header/components/LogoLink/LogoLink';
import {AuthButton} from 'app/components/core/Header/components/AuthButton';
import {Elegibility} from 'app/components/pages/Elegibility/Elegibility';

export default function HomePage() {
  const {state, connected} = useAuthentication();

  if (state !== 'initialized') {
    return <PageLoader />;
  }

  return (
    <>
      <header className="z-100 flex h-[var(--header-height)] w-full flex-none items-center justify-between border-b border-[var(--header-border-color)] bg-[var(--header-background-color)] px-10 mobile:px-5 mobile:py-2">
        <LogoLink />
        {connected && <AuthButton />}
      </header>
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Elegibility />
      </div>
    </>
  );
}
